import FaqController from '../../../controllers/faqController/controller';
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';

export default {
    name: 'SimpleTable',
    data() {
        return {
            company: '',
            searchQuery: '',
            currentPage: 1,
            pageSize: 10,
            faqList: [],
            totalPages: 0,
            totalFaqs: 0, // Total items dari backend
            faq: {
                question: '',
                answer: '',
                target: '',
                language: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
                status: ''
            },
            selectedFaq: {
                updated_by: '',
                updated_by_name: '',
                updated_on: '',
            }
        }
    },
    computed: {
        filteredFaqList() {
            return this.faqList.filter(faq => faq.question.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages() {
            return Math.ceil(this.totalFaqs / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods: {
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.faq.created_by = id;
            this.selectedFaq.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.faq.created_by_name = name;
            this.selectedFaq.updated_by_name = name;
        },
        resetForm() {
            this.faq.question = '';
            this.faq.answer = '';
            this.faq.language = '';
            this.faq.status = '';
        },
        showModal(type, id) {
            this.user();
            const faq = this.faqList.find(faq => faq.id === id);
            if (faq) {
                this.faq = faq;
        
                const modal = document.getElementById(type === 'edit' ? 'editFaq' : 'detailFaq');
        
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
        
                document.body.classList.add('modal-open');
        
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
        
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
            const modalIds = ['tambahFaq', 'editFaq', 'detailFaq'];
            modalIds.forEach(id => {
              const modal = document.getElementById(id);
              if (modal && modal.classList.contains('show')) {
                modal.classList.remove('show');
                setTimeout(() => {
                  modal.style.display = 'none';
                }, 300);
              }
            });
          
            // Hapus backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
              backdrop.classList.remove('show');
              setTimeout(() => {
                if (backdrop.parentNode) {
                  backdrop.parentNode.removeChild(backdrop);
                }
              }, 300);
            });
          
            // Hapus kelas atau atribut yang mengunci scroll pada body
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.overflow = ''; // Menghapus properti overflow jika ada
            this.fetchFaqs();
            this.resetForm();
            this.user();
        },        
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchFaqs();
            }
        },
        async fetchFaqs() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await FaqController.fetchFaqs(query, this.currentPage, this.pageSize,company);
                this.faqList = response.data;
                this.totalAllFaqs();
            } catch (error) {
                console.error('Error fetching faqs:', error);
            }
        },
        async totalAllFaqs() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await FaqController.totalAllFaqs(query, company);
                this.totalFaqs = response.data;
            } catch (error) {
                console.error('Error fetching faqs:', error);
            }
        },
        async addFaq() {
            try {
                const question = this.faq.question;
                const answer = this.faq.answer;
                // const target = this.faq.target;
                const language = this.faq.language;
                const is_active = this.faq.status;
                const company = this.company;
                const created_by = this.faq.created_by;
                const created_by_name = this.faq.created_by_name;
                const now = new Date();
                const date = now.toISOString().slice(0, 19).replace('T', ' ');
                if (!question || !answer || !language || !created_by || !created_by_name || !is_active) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const add = {
                    question: question,
                    answer: answer,
                    // target: target,
                    language: language,
                    id_company: company,
                    created_by: created_by,
                    created_by_name: created_by_name,
                    is_active: is_active,
                    created_on: date
                }
                const response = await FaqController.addFaq(add);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil menambahkan data',
                        timer: 1500
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: response.data.message,
                        timer: 1500
                    })
                }
                this.closeModal();
                this.fetchFaqs();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    text: error.message,
                    timer: 1500
                })
            }
        },        
        async updateFaq() {
            try {
                const id = this.faq.id
                const question = this.faq.question;
                const answer = this.faq.answer;
                // const target = this.faq.target;
                const language = this.faq.language;
                const is_active = this.faq.status;
                const updated_by = this.selectedFaq.updated_by;
                const updated_by_name = this.selectedFaq.updated_by_name;
                const now = new Date();
                const date = now.toISOString().slice(0, 19).replace('T', ' ');
                if (!question || !answer || !language || !updated_by || !updated_by_name || !is_active) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const update = {
                    id: id,
                    question: question,
                    answer: answer,
                    // target: target,
                    language: language,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    is_active: is_active,
                    updated_on: date
                }
                const response = await FaqController.updateFaq(update);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil mengubah data',
                        timer: 1500
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal mengubah data',
                        text: response.data.message,
                        timer: 1500
                    })
                }
                this.closeModal();
                this.fetchFaqs();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal mengubah data',
                    text: error.message,
                    timer: 1500
                })
            }
        },
        async deleteFaq(faqId){
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    await FaqController.deleteFaq(faqId)
                    this.fetchFaqs();
                    Swal.fire({
                        icon: 'success',
                        title: 'Faq berhasil dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menghapus data',
                        text: error.message,
                        timer: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'fetchFaqS'
        },
        company: {
            handler: 'fetchFaqs',
        }
    },
};